import { TableRowPlusBeforeIcon } from './TableRowPlusBeforeIcon';

/**
 * author: Austin Andrews
 * id 784BF375-370F-4DAE-985D-7BEF2FDA6951
 * name table-row-plus-before
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/table-row-plus-before.svg
 * tags
 * - Text / Content / Format 
 */
export const TableRowAddBeforeIcon = TableRowPlusBeforeIcon;
export default TableRowAddBeforeIcon